import type { PublicWidgetResponse } from '../widget-api/public-widget';
import type { MeResponse } from '../widget-api/auth-me';

/** Проверка, что тренер относится к организации из ссылки виджета (slug / конфиг). */
export function trainerOrgMatchesEmbed(
  me: MeResponse,
  orgSlug: string | null,
  widgetConfig: PublicWidgetResponse | null
): boolean {
  if (!orgSlug) {
    return true;
  }
  if (widgetConfig != null && me.organization_id != null) {
    return me.organization_id === widgetConfig.organization_id;
  }
  const slug = orgSlug.trim().toLowerCase();
  const fromMembership = (me.memberships ?? []).some(
    (m) => (m.organization_slug || '').trim().toLowerCase() === slug
  );
  if (fromMembership) {
    return true;
  }
  return me.organization_id == null;
}
